import { pxToRem } from "@deltek/specification-client/core/Utilities/unitUtils"
import { FormControlLabel, makeStyles, Radio, Theme } from "@material-ui/core"
import clsx from "clsx"
import React from "react"

const useStyles = makeStyles((theme: Theme) => ({
    radioLabel: {
        '& .MuiFormControlLabel-label': {
            fontSize: pxToRem(16),
            color: '#4D4D4D',
        },
        marginBottom: theme.spacing(0.5),
    }, icon: {
        borderRadius: '50%',
        width: 17,
        height: 17,
        boxShadow:
            'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage:
            'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage:
            'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 17,
            height: 17,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
}))

/**
 * Props for the RadioButton component
 */
interface RadioButtonProps {
    /** The value of the radio button */
    value: string
    /** The label text to display next to the radio button */
    label: string
}

/**
 * Custom styled radio button component for the manage unmapped product workflow.
 * 
 * Provides a consistent look and feel for radio button options with custom
 * Material-UI styling. Includes proper accessibility attributes and test IDs.
 * 
 * @param props - The component props
 * @returns The RadioButton component
 */
const RadioButton = ({ value, label }: RadioButtonProps) => {
    const classes = useStyles()
    return <FormControlLabel
        value={value}
        control={<Radio color="primary"
            data-testid={`manage-unmapped-radio-${value}`}
            checkedIcon={
                <span
                    className={clsx(
                        classes.icon,
                        classes.checkedIcon
                    )}
                />
            }
            icon={
                <span
                    className={
                        classes.icon
                    }
                />
            }
            inputProps={{
                'aria-label': `Select ${label}`,
            }} />}
        label={label}
        className={classes.radioLabel}
    />
}

export default RadioButton